const details = {
    name: "موبی برتر",
    enName: "shop",
    description: "موبی برتر",
    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "شرکت توسعه و طراحی سایت باران",
        link: "https://barantm.com"
    },
    meta:{
        title: "موبی برتر، فروش انواع کالای دیجیتال و لوازم جانبی در کرج",
        description : 'خرید لوازم دیجیتال، انواع موبایل، تبلت، کابل شارژر و سیم کارت همراه اول',
        canonical: '',
        locale : 'fa-IR',
        link:"https://mobibartar.com"
    }
}

export default details;
